require('../../scss/app-blog.scss');

import Application from "./application";
import BackgroundImageBehaviour from "../behaviours/background-image-behaviour";
import EqualizeBehavior from "../behaviours/equalize-behaviour";
import HideShowBehaviour from "../behaviours/hide-show-behaviour";
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import EmbeddedGallery from "../jsx/embedded-gallery";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";
import ReadingProgress from "../jsx/reading-progress";
import BlogListingBehaviour from "../behaviours/blog-listing-behaviour";
import CarouselBehaviour from "../behaviours/carousel-behaviour";
import BlockEventBehaviour from "../behaviours/block-event-behaviour";


let config = {};
config.behaviours = {
  "BackgroundImage": new BackgroundImageBehaviour(),
  "MobileMenuBehaviour": new MobileMenuBehavior(),
  "EqualizeBehaviour": new EqualizeBehavior(),
  "HideShowBehaviour": new HideShowBehaviour(),
  "ToggleClassBehaviour": new ToggleClassBehavior(),
  "CarouselBehaviour": new CarouselBehaviour(),
  "BlogListingBehaviour": new BlogListingBehaviour(),
  "BlockEventBehaviour": new BlockEventBehaviour(),
};

config.components = {
  "shortlist-count": ShortlistCount,
  "shortlist-button": ShortlistButton,
  "reading-progress": ReadingProgress,
  "embedded-gallery": EmbeddedGallery
}

new Application(config);